import find from 'lodash/find';
import get from 'lodash/get';
import filter from 'lodash/filter';
import { wallTypes as localWallTypes } from '../DataStructures/wallTypes';
import { roofTypes as localRoofTypes } from '../DataStructures/roofTypes';
import { roofWindowTypes as localRoofWindowTypes } from '../DataStructures/roofWindowTypes';
import { rainGutterTypes as localRainGutterTypes } from '../DataStructures/rainGutterTypes';

export function getOptionAttributeValue(option, attrIdentifier, defaultValue) {
  const attr = find(get(option, 'attributes'), { identifier: attrIdentifier });
  return get(attr, 'values[0].value', defaultValue);
}

export function getComponentByIdentifier(componentOptions, identifier) {
  return find(componentOptions, { identifier });
}

export function getOptionsByComponentIdentifier(componentOptions, identifier) {
  return get(getComponentByIdentifier(componentOptions, identifier), 'options') || [];
}

export function filterOptionsByAttributeValue(options, attrIdentifier, attrValue) {
  return filter(options, (option) => getOptionAttributeValue(option, attrIdentifier) === attrValue);
}

export function embedOptionsIntoLocal(localOptions, options) {
  return options.map((option) => ({
    //identifier: option.identifier,
    ...find(localOptions, { externalIdentifier: option.identifier }),
    option,
  }));
}

export function embedOptionsIntoLocalIfExists(localOptions, options) {
  const optionsWithLocalMatch = options.filter((option) =>
    find(localOptions, { externalIdentifier: option.identifier })
  );
  return embedOptionsIntoLocal(localOptions, optionsWithLocalMatch);
}

export function createLocalOptions(options, localOptionCreatorFn) {
  return options.map((option) => ({
    ...localOptionCreatorFn(option),
    option,
  }));
}

export function getEmbeddedOptionIdentifier(localOption) {
  return localOption?.option?.identifier || localOption?.identifier || localOption;
}

export function findByEmbeddedOptionIdentifier(options, embeddedOptionIdentifier) {
  return options.find(({ option: { identifier } }) => identifier === embeddedOptionIdentifier);
}

export function initLocalOptionsWithDefaultOption(localOptions) {
  return localOptions.map((localOption) => ({
    ...localOption,
    option: {
      identifier: localOption.externalIdentifier,
    },
  }));
}

export function createEmbeddedOptions(componentOptions) {
  // embed into local options
  const localOptions = {};

  const wallOptions = getOptionsByComponentIdentifier(componentOptions, 'walls');
  localOptions.walls = embedOptionsIntoLocal(
    localWallTypes,
    filterOptionsByAttributeValue(wallOptions, 'type', 'wall')
  );
  localOptions.wall_triangle = embedOptionsIntoLocal(
    localWallTypes,
    filterOptionsByAttributeValue(wallOptions, 'type', 'wall_triangle')
  );

  localOptions.colors = createLocalOptions(
    getOptionsByComponentIdentifier(componentOptions, 'colors'),
    (option) => ({
      value: getOptionAttributeValue(option, 'hex_value'),
    })
  );

  const roofOptions = getOptionsByComponentIdentifier(componentOptions, 'roof');
  localOptions.roof = embedOptionsIntoLocal(
    localRoofTypes,
    filterOptionsByAttributeValue(roofOptions, 'type', 'roof')
  );
  localOptions.roof_window = embedOptionsIntoLocal(
    localRoofWindowTypes,
    filterOptionsByAttributeValue(roofOptions, 'type', 'roof_window')
  );
  localOptions.rain_gutter = embedOptionsIntoLocalIfExists(localRainGutterTypes, roofOptions);

  return localOptions;
}
